import { SectionHeader } from "@/components/common/section-header";
import { Box, Stack } from "@mui/system";
import React from "react";
import Image from "next/image";
import sanitizeHtml from "@/utils/sanitize-html";
import { MediaCard } from "@/types/dto/common/media-card-section";

interface LegacyCardProps {
  cardData: MediaCard;
  dataParentContainerType?: string;
  moduleRankingPosition?: number;
}

const LegacyCard = ({
  cardData,
  dataParentContainerType,
  moduleRankingPosition
}: LegacyCardProps) => (
  <Stack
    component="section"
    data-track="visibility"
    data-module-name="legacy-card-section"
    data-module-ranking-position={moduleRankingPosition}
    data-parent-container-type={dataParentContainerType || "our-values-legacy-card"}
    className="full-width-container"
    sx={{
      p: { xs: "4rem 2.4rem", sm: "4rem 3.2rem", lg: "6rem 10rem" },
      gap: "4rem"
    }}
  >
    <SectionHeader
      headerText={cardData?.overlayText?.headerText || ""}
      headerTestId="legacy-card-header"
      sx={{ alignItems: "center" }}
      headerSx={{ textAlign: "center", textTransform: "none" }}
    />
    <Box
      data-testid="video-image-section"
      sx={{
        display: "flex",
        flexDirection: { lg: "row", xs: "column" },
        alignItems: "center",
        justifyContent: "center",
        gap: "2.4rem",
        height: { lg: "100%" }
      }}
    >
      <Box
        sx={{
          flex: { lg: 1 },
          position: "relative",
          width: "100%",
          height: { md: "30rem", xs: "22.5rem" },
          overflow: "hidden",
          borderRadius: "2rem"
        }}
      >
        {cardData?.media && "imageUrl" in cardData.media && cardData?.media?.imageUrl && (
          <Image
            src={cardData.media.imageUrl}
            alt={cardData?.media?.altText || cardData?.overlayText?.headerText || ""}
            fill
            quality={100}
            style={{ objectFit: "cover", objectPosition: "left", userSelect: "none" }}
            sizes="(max-width: 991px) 100vw, 1720px"
            data-testid="legacy-image"
          />
        )}
      </Box>
      <Box
        data-testid="copy-section"
        sx={{
          color: "text.primary",
          fontSize: "1.8rem",
          lineHeight: "2.7rem",
          whiteSpace: "pre-line",
          width: { lg: "48.8rem", xs: "100%" },
          flex: { lg: 1 },
          fontWeight: 500,
          "& p": { margin: 0 },
          "& a": {
            color: "secondary.main",
            textDecoration: "underline !important",
            display: { xs: "block", lg: "inline" },
            textAlign: { xs: "center" },
            fontWeight: 500
          }
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(cardData?.overlayText?.subtitle) }}
      />
    </Box>
  </Stack>
);

export default LegacyCard;
